<template>
  <component
    :is="tag"
    class="b-form"
    @submit.prevent.stop="$emit('submit', internalState)"
  >
    <slot
      :isInvalid="internalState.isInvalid"
      :messages="internalState.messages"
      :formState="internalState"
    />
  </component>
</template>

<script>
import {
  provide,
  inject,
  reactive,
  computed,
  watch,
  onMounted,
} from 'vue';
import { pascalCase } from 'change-case';
import { BFormKey } from './b-form-key';

export default {
  name: 'BForm',
  props: {
    name: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: 'form',
    },
    modelValue: {
      type: Boolean,
      default: undefined,
    },
  },
  emits: ['submit', 'update:modelValue'],
  setup($props, { emit: $emit }) {
    const getErrors = (formFields) => Object
      .values(formFields)
      .filter((field) => field?.messages?.length)
      .flatMap((field) => field.messages);

    const getChildErrors = (formChilds) => Object
      .values(formChilds)
      .filter((form) => form?.messages?.length)
      .flatMap((field) => field.messages);

    const formName = computed(() => pascalCase(`${$props.name}_form`));
    const parentForm = inject(BFormKey, undefined);
    const internalState = reactive({
      name: formName,
      childs: {},
      fields: {},
      messages: [],
      isInvalid: computed(() => Boolean(internalState.messages?.length)),
    });

    const state = reactive({
      [formName.value]: internalState,
    });

    if (parentForm) {
      parentForm.internalState.childs[formName.value] = internalState;
    }

    const registerField = (inputState) => {
      internalState.fields[inputState.value.name] = inputState;
    };

    watch([internalState.fields, internalState.childs], () => {
      internalState.messages = getErrors(internalState.fields)
        .concat(getChildErrors(internalState.childs))
        .filter(Boolean);
    });

    watch(() => internalState.isInvalid, (value) => {
      $emit('update:modelValue', value);
    });

    onMounted(() => {
      $emit('update:modelValue', internalState.isInvalid);
    });

    provide(BFormKey, {
      state,
      internalState,
      formName,
      registerField,
    });

    return { state, internalState };
  },
};
</script>

<style lang="scss">

</style>
